import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiCountriesMenuComponent } from './fi-countries-menu.component';
import { FiMenuItemSearchModule } from '@fi-shared/fi-menu-item-search/fi-menu-item-search.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [CommonModule, FiMenuItemSearchModule, MatMenuModule, MatButtonModule],
    declarations: [FiCountriesMenuComponent],
    exports: [FiCountriesMenuComponent],
})
export class FiCountriesMenuModule {}
